import Menu from "../Menu.js";
import InputTextArea from "./InputTextArea.js";
import ConfirmationArea from "./ConfirmationArea.js";
import AlertArea from "../ui/AlertArea.js";
import LoadingArea from "../ui/LoadingArea.js";

import global from "../global.js";

// const log = global.log.getLogger("f_mtac.ui.DesktopSettingsArea");
// log.setLevel(log.levels.WARN);

const DesktopSettingsArea = function () {};

global.app.bootstrap.register_module({
    name: "ui_desktop_settings_area_menu",
    deps: ["dom_loaded"],
    init: async () => {
        Menu.create({
            name: "desktop_settings_area",
            contents: ["#desktop_settings"],
            open_handler: () => {
                if (global.storage.selected_space.has_empty() && global.scene.map.loaded) {
                    global.tools.tools.duplicate_desktop.enable();
                    global.tools.tools.screen_save.enable();
                } else {
                    global.tools.tools.duplicate_desktop.disable();
                    global.tools.tools.screen_save.disable();
                }
                if (global.scene.objects.layers["resources"].empty) {
                    global.tools.tools.delete_resources.disable();
                } else {
                    global.tools.tools.delete_resources.enable();
                }
                if (global.scene.objects.layers["scene"].empty && global.scene.objects.layers["notes"].empty) {
                    global.tools.tools.delete_objects.disable();
                } else {
                    global.tools.tools.delete_objects.enable();
                }
                global.scene.disable_draggable_tools();
            },
            close_handler: () => {
                if (global.scene.objects.layers.media.ids.length > 0) {
                    global.scene.enable_draggable_tools();
                }
            },
            close_timer: true
        });
    }
});

global.app.bootstrap.register_module({
    name: "ui_desktop_settings_area_tools",
    deps: ["dom_loaded", "tools"],
    init: async () => {
        global.tools.register({
            position: "#desktop_settings",
            name: "desktop_rename",
            icon: "rename f_mtac-icon-xlg",
            handler: async () => {
                let name = await InputTextArea.interact({
                    current_text: global.scene.map.name,
                    tip: global.internationalization.text("sitac.Tactical-situation-name")
                });
                if (name === null) {
                    // the user cancelled
                    return;
                }
                global.scene.map.name = name;
            }
        });

        global.tools.register({
            position: "#desktop_settings",
            name: "duplicate_desktop",
            icon: "duplicate f_mtac-icon-xlg",
            handler: async (tool) => {
                var selected_space = global.storage.selected_space;
                if (!selected_space) {
                    return;
                }
                var selected_context = global.storage.selected_context;
                if (!selected_context) {
                    return;
                }
                var confirmation = await ConfirmationArea.interact({
                    title: global.internationalization.text("global.Duplicate"),
                    tip1: global.internationalization.text("sitac.Duplicate-sitac")
                });
                if (!confirmation) {
                    return;
                }
                var new_desktop_index = null;
                for (let desktop_index = 0; desktop_index < selected_space.context.length; desktop_index++) {
                    let context = selected_space.context[desktop_index];
                    if (!(await selected_space.context_is_empty(context))) {
                        continue;
                    }
                    if (new_desktop_index === null || new_desktop_index < selected_context.index) {
                        new_desktop_index = desktop_index;
                    }
                }
                if (new_desktop_index === null) {
                    await AlertArea.interact({
                        type: "danger",
                        tip1: global.internationalization.text("sitac.Duplication-not-possible")
                    });
                    return;
                }
                var new_name = InputTextArea.interact({
                    current_text: global.scene.map.name,
                    tip: global.internationalization.text("sitac.Tactical-situation-name"),
                    error_message: global.internationalization.text("sitac.Tactical-situation-name-required")
                });
                new_name = await new_name;
                if (new_name === null) {
                    return;
                }
                if (new_name === "") {
                    new_name = "";
                }
                await global.storage.delete({desktop_index: new_desktop_index});
                await global.storage.duplicate({desktop_index: selected_context.index, new_desktop_index});
                let {new_context} = await global.storage.open({desktop_index: new_desktop_index});
                if (selected_space.has_empty()) {
                    tool.enable();
                } else {
                    tool.disable();
                }
                new_context.name = new_name;
                await new_context.data_commit();
            }
        });

        global.tools.register({
            name: "screen_save",
            icon: "export_jpg f_mtac-icon-xlg",
            position: "#desktop_settings",
            handler: async () => {
                LoadingArea.interact({
                    tip1: global.internationalization.text("sitac.Sitac-export-in-progress")
                });
                if (global.view.is_gis) {
                    global.view.ol_driver.export_ongoing = true;
                }
                let position = global.view.locked_position;
                global.view.unlock_position();

                await global.scene.map.center();
                global.scene.mode_switcher.mode = "resources"; // to be sure to not display graphics handles

                // AGPOC-8535 : for GIS case, the export is done after compute_and_launch_function called after centering
                // except if background image hasn't changed => in that case call export immediately
                let gis_context = global.storage.selected_context.data.gis;
                let ol_view = global.view.ol_driver.ol_map.getView();
                let wait_before_calling_export = false;
                if (global.view.is_gis){
                    wait_before_calling_export = true;
                    if ((gis_context.center[0] === ol_view.getCenter()[0] && gis_context.center[1] === ol_view.getCenter()[1] && gis_context.resolution === ol_view.getResolution())) {
                        wait_before_calling_export = false;
                    }
                }

                if (wait_before_calling_export === false) {
                    global.scene.export_map();
                }

                if (position !== null && wait_before_calling_export === false) {
                    global.view.lock_position(position);
                }
            }
        });

        global.tools.register({
            name: "delete_map",
            icon: "delete_map f_mtac-icon-xlg",
            position: "#desktop_settings",
            handler: async () => {
                const layers = global.scene.objects.layers;
                let confirmation = await ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1:
                        layers.scene.ids.length !== 0 || layers.resources.ids.length !== 0 || layers.notes.ids.length !== 0 ? global.internationalization.text("sitac.Delete-sitac-and-content") : global.internationalization.text("sitac.Delete-sitac")
                });
                if (!confirmation) {
                    return;
                }
                const selected_context = global.storage.selected_context;
                if (selected_context === null) {
                    return;
                }
                const desktop_index = selected_context.index;
                // delete media if needed (not deleted by delete context as media belongs to space)
                global.scene.objects.tx_delete_all_media("resources");
                await selected_context.space.delete_context_remote({desktop_index});
                await selected_context.space.delete_context({desktop_index});
                await selected_context.space.open_context({desktop_index});
            }
        });

        global.tools.register({
            name: "delete_objects",
            icon: "delete_objects f_mtac-icon-xlg",
            position: "#desktop_settings",
            handler: () => {
                ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("sitac.Delete-all-drawings")
                }).then((confirmed) => {
                    if (!confirmed) {
                        return;
                    }
                    global.scene.objects.tx_delete_all("scene");
                    global.scene.objects.tx_delete_all("notes");
                    global.tools.tools.delete_objects.disable();
                });
            }
        });

        global.tools.register({
            name: "delete_resources",
            icon: "delete_resources f_mtac-icon-xlg",
            position: "#desktop_settings",
            handler: () => {
                ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("sitac.Delete-all-resources-and-media")
                }).then((confirmed) => {
                    if (!confirmed) {
                        return;
                    }
                    global.scene.objects.tx_delete_all("resources");
                    global.tools.tools.delete_resources.disable();
                });
            }
        });
    }
});

export default new DesktopSettingsArea();
